<div *ngIf="this.paymentStatusResponse?.paymentStatus" class="paymentstatus-container">
    <div class="paymentstatus">
        <div class="failed-response">
            <h3>{{ "paymentStatus." + this.paymentStatusResponse?.paymentStatus | translate }}!</h3>
            <h3>{{"paymentStatus.simplePayTransactionId" | translate }}: {{ this.paymentStatusResponse?.simpleTransactionId }}</h3>
            <h3 *ngIf="isPaymentStatusFailed">{{"paymentStatus.statusFailedText" | translate }}</h3>
            <h3>{{"paymentStatus.orderId" | translate }}: {{this.paymentStatusResponse?.customerOrderReference}}</h3>
            <p>{{"paymentStatus.emailText" | translate }}</p>
        </div>
    </div>
    <div *ngIf="isPaymentStatusFailed" class="go-to-pay">
        <button (click)="goToPay()">{{"shoppingCart.goToPayOnceMore" | translate }}</button>
    </div>
</div>
